<div class="trainingQuizAnswerModal">
    <p-dialog
    header="Training Quiz Answer"
    [(visible)]="isQuizVisible"
    [modal]="true"
    [draggable]="false"
    [style]="{ width: '90vw', height: '100vw' ,'margin-left': '1em' }"
>     
<div *ngIf="isQuizReadOnly">
    <p class="m-0 text-base">{{instructionToCloseModal}}</p>
        <app-quiz-completion 
            [quizDataToDisplay]="quizData" 
            [quizAnswers]="quizResponse" 
            [isQuizReadOnly]="isQuizReadOnly">
        </app-quiz-completion>
    </div>
    </p-dialog>
</div>
